import {
  getEndPoint,
  getPluginType,
  getStartPoint,
  select,
  withoutNormalizing,
  getTableGridAbove,
  ELEMENT_TH,
} from '@udecode/plate';
import { Path } from 'slate';

export const withSetFragmentDataTable = (editor) => {
  const { setFragmentData } = editor;

  editor.setFragmentData = (
    data,
    originEvent,
  ) => {
    const tableEntry = getTableGridAbove(editor, {
      format: 'table',
    })?.[0];
    const selectedCellEntries = getTableGridAbove(editor, {
      format: 'cell',
    });

    const initialSelection = editor.selection;

    if (!tableEntry || !initialSelection) {
      setFragmentData(data, originEvent);
      return;
    }

    const selectionStart =
      Path.compare(initialSelection.anchor.path, initialSelection.focus.path) <
      1
        ? initialSelection.anchor
        : initialSelection.focus;

    const [tableNode, tablePath] = tableEntry;
    const tableRows = tableNode.children;

    const tableSelectionStart = selectionStart.path.slice(
      tablePath.length,
      tablePath.length + 2,
    );

    const [y, x] = tableSelectionStart;

    let textCsv = '';
    let textTsv = '';

    const divElement = document.createElement('div');
    const tableElement = document.createElement('table');

    /**
     * Cover single cell copy | cut operation. In this case, copy cell content instead of table structure.
     */
    if (
      tableEntry &&
      initialSelection &&
      selectedCellEntries.length === 1 &&
      (originEvent === 'copy' || originEvent === 'cut')
    ) {
      setFragmentData(data);
      return;
    }

    withoutNormalizing(editor, () => {
      tableRows.forEach((row, rowIndex) => {
        const rowCells = row.children;
        const rowPath = tablePath.concat(y + rowIndex);

        const cellStrings = [];
        const rowElement =
          row.type === getPluginType(editor, ELEMENT_TH)
            ? document.createElement('th')
            : document.createElement('tr');

        rowCells.forEach((_, cellIndex) => {
          const cellPath = rowPath.concat(x + cellIndex);

          data.clearData();

          // select cell by cell
          select(editor, {
            anchor: getStartPoint(editor, cellPath),
            focus: getEndPoint(editor, cellPath),
          });

          // set data from selection — DOM may be out of sync during programmatic
          // selection changes inside withoutNormalizing, so guard against null errors
          try {
            setFragmentData(data);
            cellStrings.push(data.getData('text/plain'));
            const cellElement = document.createElement('td');
            cellElement.innerHTML = data.getData('text/html');
            rowElement.appendChild(cellElement);
          } catch (e) {
            cellStrings.push('');
            rowElement.appendChild(document.createElement('td'));
          }
        });

        tableElement.appendChild(rowElement);

        textCsv += `${cellStrings.join(',')}\n`;
        textTsv += `${cellStrings.join('\t')}\n`;
      });

      // select back original cells
      select(editor, initialSelection);

      divElement.appendChild(tableElement);
    });

    data.setData('text/csv', textCsv);
    data.setData('text/tsv', textTsv);
    data.setData('text/plain', textTsv);
    data.setData('text/html', divElement.innerHTML);

    // set slate fragment
    const selectedFragmentStr = JSON.stringify(tableNode);
    const encodedFragment = window.btoa(
      encodeURIComponent(selectedFragmentStr),
    );
    data.setData('application/x-slate-fragment', encodedFragment);
  };

  return editor;
};
